import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

window.gt = {
  lookBuilderAssetsBaseUrl: 'v60',
};

ReactDOM.render(<App />, document.getElementById('root'));
